import { useState } from 'react';
import { X, XCircle } from 'lucide-react';

interface RejectModalProps {
  stand: any;
  eventId: string;
  event: any;
  onReject: (reason: string) => void;
  onClose: () => void;
}

export function RejectModal({ stand, eventId, event, onReject, onClose }: RejectModalProps) {
  const [rejectReason, setRejectReason] = useState('');

  const handleReject = () => {
    onReject(rejectReason);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[200] p-4 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="w-5 h-5" />
        </button>
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-xl bg-red-50 flex items-center justify-center">
            <XCircle className="w-5 h-5 text-red-500" />
          </div>
          <div>
            <h3 className="text-base font-bold text-gray-900">Rifiuta Prenotazione</h3>
            <p className="text-xs text-gray-500">Stand {stand?.label} — {stand?.company}</p>
          </div>
        </div>
        <div className="mb-5">
          <label className="block text-xs font-semibold text-gray-700 mb-2">
            Motivazione del rifiuto <span className="text-gray-400 font-normal">(opzionale)</span>
          </label>
          <textarea
            value={rejectReason}
            onChange={(e) => setRejectReason(e.target.value)}
            placeholder="Es: Documentazione incompleta, stand già assegnato, ecc."
            rows={4}
            className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:ring-2 focus:ring-red-200 focus:border-red-400 outline-none transition-all resize-none"
          />
        </div>
        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2.5 border border-gray-200 text-gray-600 rounded-xl font-bold hover:bg-gray-50 transition-all text-sm"
          >
            Annulla
          </button>
          <button
            onClick={handleReject}
            className="flex-1 px-4 py-2.5 bg-red-500 text-white rounded-xl font-bold hover:bg-red-600 transition-all text-sm flex items-center justify-center gap-2 shadow-lg shadow-red-200"
          >
            <XCircle className="w-4 h-4" />
            Conferma Rifiuto
          </button>
        </div>
      </div>
    </div>
  );
}
